export default {
	subtitle: "Credit card transactions Brazil (Deprecated)",
  path: "deprecated_transaction_3ds_cc_br",
	paragraphs: [
    "For Brazil you will create a credit card transaction calling our API, using the from_credit_card field. Check the payload below to see.",
    "For sandbox, you can use a checkout page sample available on our portal or via the following link. This page will help you understand the needed information and the whole flow from the credit transactions.",
    "We highly recommend testing the checkout page first before initiating direct API calls, because you can adapt it to your front-end environment.",
    "To create using the API call you will use the following endpoint: "
  ],
  hyperlink: {
    linkPath: "/static/3DSSamplesBR_Deprecated.zip",
    linkText: "Download sample page"
  },
  request: {
    method: "POST",
    endpoint: "/transactions",
    payload: {
      "transaction": {
        "currency": "BRL",
        "exchange_currency": "one of: BRL, USD, EUR",
        "value": "777.00",
        "from_credit_card": {
          "card_number": "5201561050025011",
          "card_expiration_date": "09/2024",
          "card_security_code": "123",
          "card_brand": "Mastercard",
          "fullname": "Jose Silva"
        },
        "threeds": {
          "softDescriptor": "FACILIA*PAY",
          "urlSite3DS": "sandbox-portal.facilitapay.com",
          "code3DS": "code3ds",
          "httpAcceptBrowserValue": "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
          "httpBrowserLanguage": "pt-BR",
          "httpBrowserJavaEnabled": "N",
          "httpBrowserJavaScriptEnabled": "true",
          "httpBrowserColorDepth": "24",
          "httpBrowserScreenHeight": "430",
          "httpBrowserScreenWidth": "1536",
          "httpBrowserTimeDifference": "180",
          "userAgentBrowserValue": "Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:98.0) Gecko/20100101 Firefox/98.0",
          "ipAddress": "191.19.91.19"
        },
        "to_bank_account_id": "{{partner_internal_bank_account_id}}",
        "subject_id": "9e70a3f2-913d-48c8-9bc2-cf2a23c34ac8"
      }
    },
    responses: {
      "data": {
        "value": "128.00",
        "to_bank_account": {
          "routing_number": null,
          "owner_name": "REARDEN STEEL CO.",
          "owner_document_number": "2348909854385",
          "owner_company": {
            "social_name": "POWER HOME THEATER",
            "id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
            "document_type": "tax_id",
            "document_number": "2348909854385"
          },
          "internal": true,
          "intermediary_bank_account": null,
          "id": "1ae24ce1-0a08-4c70-8aaa-c86d89ab32fa",
          "iban": null,
          "flow_type": "cash_in",
          "currency": "USD",
          "branch_number": null,
          "branch_country": null,
          "bank": {
            "swift": null,
            "name": "Internal",
            "id": "6facab8d-573e-44d0-a4bd-ce2600368263",
            "code": "999"
          },
          "account_type": "conta-corrente",
          "account_number": null,
          "aba": null
        },
        "threeds_challenge": {
          "three_ds_version": "2.1.0",
          "pareq": "eyJtZXNzYWdlVHlwZSI6IkNSZXEiLCJtZXNzYWdlVmVyc2lvbiI6IjIuMS4wIiwidGhyZWVEU1NlcnZlclRyYW5zSUQiOiJiYjEwMTE2OC0wMTE0LTQxYTQtOWQwMi01YjdkMzRhZGZlOTgiLCJhY3NUcmFuc0lEIjoiZjZkMGE0ZWItOTNkZC00MjAzLWIxYzAtZjIxM2I1ZDViNDAzIiwiY2hhbGxlbmdlV2luZG93U2l6ZSI6IjAyIn0",
          "authentication_transaction_id": "rwqfeFXSTBwfvgif9DR0",
          "acs_url": "https://0merchantacsstag.cardinalcommerce.com/MerchantACSWeb/creq.jsp"
        },
        "subject_is_receiver": false,
        "subject_id": "59c37274-4f3f-4d4b-a500-d4d91a3a7798",
        "subject": {
          "updated_at": "2022-04-13T19:16:17.782243",
          "status": "approved",
          "social_name": "Jose Silva",
          "short_id": "17581CEA",
          "required_clearance_level": 1,
          "references": [],
          "phone_number": "888589-6545",
          "net_monthly_average_income": "4000.00",
          "inserted_at": "2022-02-24T22:38:18.596041",
          "id": "59c37274-4f3f-4d4b-a500-d4d91a3a7798",
          "fiscal_country": "Brasil",
          "email": "josesilva@gmail.com",
          "document_type": "cpf",
          "document_number": "00000000949",
          "clearance_level": 1,
          "birth_date": null,
          "address_street": "Rua Gurilandia",
          "address_state": "MG",
          "address_postal_code": "35218084",
          "address_number": "15",
          "address_country": "Brasil",
          "address_complement": null,
          "address_city": "Birigui"
        },
        "status": "pending",
        "source_name": "Jose Silva",
        "source_document_type": "cpf",
        "source_document_number": "00000000949",
        "short_id": "7C93CC8A",
        "inserted_at": "2022-04-13T19:16:17.747187",
        "id": "0b20a093-c098-48c0-b0fd-9d9365ccf5fb",
        "from_credit_card": {
          "status": "tokenized",
          "inserted_at": "2022-04-13T19:16:17.745791",
          "id": "5c548fc3-7218-4413-9bfd-4973896fb807"
        },
        "from_bank_account": null,
        "for_exchange": true,
        "exchange_under_request": false,
        "exchange_currency": "USD",
        "estimated_value_until_exchange": false,
        "currency": "BRL",
        "cleared": true,
        "bank_transaction": null
      }
    }
  },
  parameterPayload: [
     {
      name: "transaction",
      type: "object",
      required: true,
      description: "transaction data containing at least the following required values:"
    },
    {
      name: "transaction.currency",
      type: "string",
      required: true,
      description: "Origin currency"
    },
    {
      name: "transaction.exchange_currency",
      type: "string",
      required: true,
      description: "Destination currency"
    },
    {
      name: "transaction.value",
      type: "string",
      required: true,
      description: "Total amount to be transferred"
    },
      {
      name: "transaction.from_credit_card",
      type: "object",
      required: true,
      description: "Data containing at least the following required values:"
    },
    {
		name: "transaction.from_credit_card.card_number",
		type: "string",
		required: true,
		description: "The card number without spaces"
    },
    {
      name: "transaction.from_credit_card.card_expiration_date",
      type: "string",
      required: true,
      description: "Card expiration date in MM/YY format"
    },
    {
      name: "transaction.from_credit_card.card_brand",
      type: "string",
      required: true,
      description: "Card brand, such as Visa, Mastercard, or Elo"
    },
    {
      name: "transaction.from_credit_card.card_security_code",
      type: "string",
      required: true,
      description: "Partner's customer/company UUID"
    },
    {
      name: "transaction.from_credit_card.fullname",
      type: "string",
      required: true,
      description: "Cardholder's full name"
    },
    {
      name: "transaction.threeds",
      type: "object",
      required: true,
      description: "Data containing at least the following required values:"
    },
    {
      name: "transaction.threeds.softDescriptor",
      type: "string",
      required: true,
      description: "It is a short description of the merchant that will appear on the buyer's credit card statement. It has a limit of 17 characters."
    },
    {
      name: "transaction.threeds.urlSite3DS",
      type: "string",
      required: true,
      description: "It is the URL of the merchant's website where the transaction is taking place without 'https://'."
    },
    {
      name: "transaction.threeds.code3ds",
      type: "string",
      required: true,
      description: "It is a unique code generated by the card issuer for the specific transaction."
    },
    {
      name: "transaction.threeds.codeAntiFraud",
      type: "string",
      required: true,
      description: "It is a uniq UUID for the anti-fraud system used by the payment processor. You must genarate it for every trasnaction you create."
    },
    {
      name: "transaction.threeds.httpAcceptBrowserValue",
      type: "string",
      required: true,
      description: "Value of the Accept Header of the Customer's browser."
    },
    {
      name: "transaction.threeds.httpBrowserLanguage",
      type: "string",
      required: true,
      description: "Customer's browser language according to https://www.techonthenet.com/js/language_tags.php"
    },
    {
      name: "transaction.threeds.httpBrowserJavaEnabled",
      type: "string",
      required: true,
      description: "If JAVA enabled send Y value, otherwise N."
    },
    {
      name: "transaction.threeds.httpBrowserJavaScriptEnabled",
      type: "string",
      required: true,
      description: "If JAVA SCRIPT enabled send Y value, otherwise N."
    },
    {
      name: "transaction.threeds.httpBrowserColorDepth",
      type: "string",
      required: true,
      description: "Number of bits used to display images."
    },
    {
      name: "transaction.threeds.httpBrowserScreenHeight",
      type: "string",
      required: true,
      description: "Height of the Customer's screen resolution."
    },
    {
      name: "transaction.threeds.httpBrowserScreenWidth",
      type: "string",
      required: true,
      description: "Width of the Customer screen resolution."
    },
    {
      name: "transaction.threeds.httpBrowserTimeDifference",
      type: "string",
      required: true,
      description: "Difference in minutes between GMT time and that of the Customer's browser."
    },
    {
      name: "transaction.threeds.userAgentBrowserValue",
      type: "string",
      required: true,
      description: "The exact value of the User Agent Header."
    },
    {
      name: "transaction.threeds.ipAddress",
      type: "string",
      required: true,
      description: "It is the IP address of the Customer's device."
    },
    {
      name: "transaction.to_bank_account_id",
      type: "string",
      required: true,
      description: "Partner internal bank account ID"
    },
    {
      name: "transaction.subject_id",
      type: "string",
      required: true,
      description: "The ID of the person or company involved in the transaction."
    },
  ],
  domainsProperties: [
    {name: "4000000000002701", values: "Test Case 1: Successful Frictionless Authentication (Visa)"},
    {name: "5200000000002235", values: "Test Case 1: Successful Frictionless Authentication (Mastercard)"},
    {name: "4000000000002925", values: "Test Case 2: Failed Frictionless Authentication"},
    {name: "4000000000002719", values: "Test Case 3: Attempts Stand-In Frictionless Authentication"},
    {name: "4000000000002313", values: "Test Case 4: Unavailable Frictionless Authentication from the Issuer"},
    {name: "4000000000002537", values: "Test Case 5: Rejected Frictionless Authentication by the Issuer"},
    {name: "4000000000002990", values: "Test Case 6: Authentication Not Available on Lookup"},
    {name: "4000000000002446", values: "Test Case 7: Error on Lookup"},
    {name: "4000000000002354", values: "Test Case 8: Timeout on cmpi_lookup Transaction"},
    {name: "4000000000002503", values: "Test Case 9: Successful Step Up Authentication (Visa)"},
    {name: "5200000000001096", values: "Test Case 9: Successful Step Up Authentication (Mastercard)"},
    {name: "4000000000002370", values: "Test Case 10: Failed Step Up Authentication"},
    {name: "4000000000002420", values: "Test Case 11: Step Up Authentication is Unavailable"},
    {name: "4000000000002644", values: "Test Case 12: Error on Authentication"},
    {name: "4000000000002560", values: "Test Case 13: Bypassed Authentication"},
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Deprecated/Transaction/CreditCardBR.js